import React from 'react';
import './TooltipComponent.scss';

export interface TooltipProps {
  text: string;
}

const TooltipComponent: React.FC<TooltipProps> = ({ text = '' }) => {
  return (
    <div className="tooltip">
      <div className="tooltip-small-triangle"></div>
      <div className="tooltip-wrapper">
        <span>{text}</span>
      </div>
    </div>
  );
};

export default TooltipComponent;
